module.exports = __webpack_public_path__ + "static/media/lodge.3202a642.svg";